import React from "react";
import styled from "styled-components";
import Login from "./login";
import Profile from "./profile";

const StyledSideTips = styled.div`
  background-color: ${({ theme }) => theme.secondBackgroundColor};
  box-shadow: ${({ theme }) => theme.boxShadow};

  height: 310px;
  display: flex;
  justify-content: center;
`;

const SideTips = ({ onLogin, onLogout, user }) => {
  return (
    <StyledSideTips>
      {user ? <Profile onLogout={onLogout} user={user} /> : <Login onLogin={onLogin} />}
    </StyledSideTips>
  );
};

export default SideTips;
